import o from "./ghl-ui.es733.js";
import e from "./ghl-ui.es743.js";
import i from "./ghl-ui.es744.js";
function n(t, r) {
  return i(e(t, r, o), t + "");
}
export {
  n as default
};
